var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCat404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.92,85.56q-2.52-2.48-5.2-4.8C380.53,48.5,331.15,31.62,283,24.8c-48.8-6.91-100.56-.65-142.61,26.49q-7,4.55-13.59,9.76C91.76,89,75.07,128,70.48,171.92,67,205.45,50.32,231.71,38.89,262.7,26.46,296.41,26.61,337.87,43,370.3c19.46,38.51,58.33,58.19,97.91,70.17,66.83,20.22,141.73,20.16,206.85-6.35,45.14-18.38,91-49.95,109.57-96.7,16.55-41.76,17.34-88.66,11.92-132.72C464,161.86,455,116.93,422.92,85.56Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.92,85.56q-2.52-2.48-5.2-4.8C380.53,48.5,331.15,31.62,283,24.8c-48.8-6.91-100.56-.65-142.61,26.49q-7,4.55-13.59,9.76C91.76,89,75.07,128,70.48,171.92,67,205.45,50.32,231.71,38.89,262.7,26.46,296.41,26.61,337.87,43,370.3c19.46,38.51,58.33,58.19,97.91,70.17,66.83,20.22,141.73,20.16,206.85-6.35,45.14-18.38,91-49.95,109.57-96.7,16.55-41.76,17.34-88.66,11.92-132.72C464,161.86,455,116.93,422.92,85.56Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.92,
    y: 37.47,
    width: 123.46,
    height: 179.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.96,
    y: 52.05,
    width: 103.39,
    height: 150.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.18,
    y: 87.23,
    width: 54.94,
    height: 79.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.12,
    y: 37.47,
    width: 72.19,
    height: 93.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.99,
    y: 45.04,
    width: 60.45,
    height: 77.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.16,
    y: 63.3,
    width: 32.12,
    height: 41.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,138.32s-20.72-14.75-23.51-33.07,1.6-43.83-8.37-57.38S80.7,33,78.54,54.64c-1.6,15.94,16.73,12,26.29,8.37s12.75,8.77,12,34.66,15.93,53.79,32.67,59.77S159,138.32,159,138.32Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,226.88s3.85,8.55,10.05,13.47,10,4.92,10,4.92-1.07,6.62,1.07,9.83,17.1,26.08,19.45,28,8.12,1.71,12.19,1.49,5.13-2.35,2.78-6.41-8.56-5.35-8.56-5.35-2.35-7.91-.21-15.6,4.49-12,10.26-14.33,28.86-2.13,30.36-.21a30.31,30.31,0,0,0,16.89,12.19c10.69,3,16.67,1.49,19.88,4.49s2.56,9.62,7.48,10.26,7.7-3,6.2-9.41-5.77-10.05-11.54-16-14.33-13.47-16.89-20.1-12-30.78-18.81-45.53-13.9-40.62-44-54.09-66.27,1.93-77,18.6-15,36.13-9.84,59,11.33,20.95,11.76,34,.21,22.45,7.48,33.57,10.91,13.47,14.33,13.89,8.55.86,9.19-1.71.43-7.05-2.14-8.76-5.34.21-7.69-3.42-5.35-19.24-1.07-24.8S181.49,235.86,181.91,226.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.27,180.92s-18.17,15-20.1,36.34,6.2,13.68,9.62,11.55,2.57,4.06,2.57,4.06-2.35,8.55-2.35,12.4,1.92,8.76,5.77,6.84-2.14-5.35,5.35-16.25,7.26-6.63,22.66-21.16,5.77-36.35-1.71-36.13-14.11,7.69-14.33,3.63S215.9,179,212.27,180.92Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,129.88c-6.37,3.89-11.41,8.49-14.43,13.2-10.69,16.68-15,36.13-9.84,59a76.55,76.55,0,0,0,5,15.5c3.4,6.16,6.64,9.08,8.5,11.87,3.42,5.13,11.12,5.77,11.76-6.42s-16.68-40.83-13-68.19C155.53,142.63,160.73,134.81,166,129.88Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,170.37c-6.29-14.83-15.37-34.66-40.49-45.89a60.78,60.78,0,0,0-25.23-5.12c-10.23,1.58-24.15,6.75-35.27,22-20.1,27.58,2.56,72.69,10.69,76.53s8.33-.64,10.47-21.16,31.21-40.4,38.91-38.91-9,7.91-8.77,13,1.5,3.64,19-1.92A43.14,43.14,0,0,1,269,170.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,226.88s3.85,8.55,10.05,13.47,10,4.92,10,4.92-1.07,6.62,1.07,9.83,17.1,26.08,19.45,28,8.12,1.71,12.19,1.49,5.13-2.35,2.78-6.41-8.56-5.35-8.56-5.35-2.35-7.91-.21-15.6,4.49-12,10.26-14.33,28.86-2.13,30.36-.21a30.31,30.31,0,0,0,16.89,12.19c10.69,3,16.67,1.49,19.88,4.49s2.56,9.62,7.48,10.26,7.7-3,6.2-9.41-5.77-10.05-11.54-16-14.33-13.47-16.89-20.1-12-30.78-18.81-45.53-13.9-40.62-44-54.09-66.27,1.93-77,18.6-15,36.13-9.84,59,11.33,20.95,11.76,34,.21,22.45,7.48,33.57,10.91,13.47,14.33,13.89,8.55.86,9.19-1.71.43-7.05-2.14-8.76-5.34.21-7.69-3.42-5.35-19.24-1.07-24.8S181.49,235.86,181.91,226.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,210.27c-.2-1.11-.36-2.19-.46-3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,226.88a118.91,118.91,0,0,1-4.06-13.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27,250.45s4.11,2.26,8.05.48,4.17-4.58,4.17-4.58-6.1-2.59-8.73-1.24A7,7,0,0,0,257.27,250.45Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,208.73s-3.36,17-2.73,20,5.88-2.1,5.88-2.1.42,14.5,4.42,16.18,4.62-1.26,4.62-1.26a13.33,13.33,0,0,0,8,2.94c4.62,0,9,0,10.51,2.53a8.8,8.8,0,0,0,8.2,4.62c4-.21,7.78-4.2,9.46-4.41s4.41,1.68,8.62-.21,5.67-8.41,6.72-8.83,7.15-4,10.3-3.58,7.36-9.46,7.36-9.46,2.73,2.53,3.78-.42.42-14.08.42-14.08,4.63,2.52,4.21-2.52-8-16-8-16-7.78-13.24-31.53-15.76c0,0-19.76-1.69-32.79,7.56S214.36,208.73,214.36,208.73Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.07,191.91s-3.15-4-11.56-4.62-20.77-.69-20.37,3,19.13,20.93,19.13,20.93",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.14,190.31s7.75-.92,19.74,3.49,10.06,8.19,8.19,11.35c-2.73,4.63-8,6.3-8.8,6.09S200.74,198.37,201.14,190.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.48,186.6s1.21-4.95,8.59-9,18.59-9.26,19.77-5.73-8.68,27-8.68,27",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.84,171.85s-7.43,2.39-16.49,11.39-5.74,11.64-2.73,13.74c4.41,3.06,9.86,2.41,10.54,1.87S299.56,179,295.84,171.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,233.44c-.89-13.78-13.34-11.81-14.82-9.67s-3.53,1.58-4.1-2.31S256.89,207,253,211.24s-7.06,13.59-5.47,16.06-.53,4.23-2.82,4-6.53,1.06-8.82,6.53c-1.47,3.5-.7,4.9,0,5.46,4.09,0,7.78.26,9.1,2.52a8.8,8.8,0,0,0,8.2,4.62c4-.21,7.78-4.2,9.46-4.41s4.41,1.68,8.62-.21,5.67-8.41,6.72-8.83S284.91,233.21,288.12,233.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,225.92c-1-2.9.53-6.08,7.55-5.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,217s7-6.6,10.7,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.76,
    y1: 242.41,
    x2: 235.16,
    y2: 247.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.62,
    y1: 245.05,
    x2: 241.58,
    y2: 249.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.19,
    y1: 246.56,
    x2: 244.22,
    y2: 253.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.13,
    y1: 238.75,
    x2: 285.65,
    y2: 238.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.11,
    y1: 240.84,
    x2: 280.47,
    y2: 243.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.1,
    y1: 242.45,
    x2: 279.3,
    y2: 247.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.4,227.1c-1.21,2-3.11,3-4.25,2.33s-1.09-2.86.12-4.85,3.11-3,4.25-2.33S272.61,225.12,271.4,227.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,232.06c1.81,1.45,4,1.79,4.79.75s.05-3.07-1.77-4.52-4-1.79-4.79-.75S244.29,230.61,246.1,232.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,235.49c-.1-1.28-1.66-1.49-2.93-1.31-2,.28-5.16.94-5.4,2.4-.37,2.17,2.49,4.84,5.38,4.27C263.18,240.46,264.33,237.72,264.15,235.49Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.2,
    y1: 240.85,
    x2: 261.77,
    y2: 244.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "149.04 219.59 178.58 283.53 155.13 283.53 147.12 240.11 149.04 219.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.53 283.63 81.69 283.63 95.57 197.54 163.41 197.54 149.53 283.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.32 283.63 78.48 283.63 92.36 197.54 160.2 197.54 146.32 283.63",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.43 272.64 88.91 272.64 99.25 208.53 149.77 208.53 139.43 272.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,227.74c0-.58-.11-1.06-.14-1.39-.39-3.77-1.73-7.81-4.92-10.15-4.13-3-6.88-3.3-6.88-3.3l.82,7.71-8-1.93v7.43l-5.23-2.75s-1.37,4.13,4.13,8.81,18.43,2.75,18.44,2.75C124.36,234.5,124.22,230.25,124,227.74Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,246.33c-.11-.41-.21-.75-.28-1-.75-2.64-2.22-5.35-4.79-6.61a11.5,11.5,0,0,0-5.32-1.48l1.56,5.38-5.92-.36.94,5.29-4.08-1.3s-.46,3.12,4.06,5.76,13.47-.37,13.48-.38C118.67,251.1,118,248.09,117.55,246.33Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,250.6s-3-6.33-.28-18.16a60,60,0,0,1,7.71-19s1.65,1.1.82,19-4.68,25.87-4.68,25.87Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,265.74a13.21,13.21,0,0,0-8.53-6.33c-6.33-1.65-22.84.28-22.84.28s4.4,5.77,16.79,8.53S133,265.74,133,265.74Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.2,251.66s12.46,4.17,18.24,13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,234.92c-.45.2,15,34.17,17.2,37.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "79.04 460.2 79.04 294.51 407.26 294.51 407.26 462.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.04,
    y: 294.51,
    width: 328.21,
    height: 13.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.06,
    y: 314.37,
    width: 289.71,
    height: 66.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.67,
    cy: 348.57,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.06,
    y: 391.17,
    width: 289.71,
    height: 66.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.67,
    cy: 425.38,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.15,
    y: 284.03,
    width: 361.86,
    height: 16.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vase--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.21,397c.16,1.13-13.36,3.92-30.19,6.22s-30.59,3.26-30.75,2.12,13.36-3.92,30.19-6.22S386.06,395.87,386.21,397Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.94,398.12a105.73,105.73,0,0,1-11.27,24.41C319.4,436,306.15,457,305.11,463.09S308,457.64,326,443c18.21-14.86,19.51-49.15,19.51-49.15Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.06,393.5s4.89,16.57-.94,42.48-7.3,37-7.3,37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.06,390.81s8.74,31,15.09,41.78S377,446.13,377,446.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,432.59s-5.83,3-4.33,12.21C367.1,458.73,382.27,460,382.27,460l1.71-4,4.51.13s.7-11.34-5.24-19.15A12.17,12.17,0,0,0,369.15,432.59Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.79,449.93s-3.93-1.34-13.49,8.22-7.82,25.05-7.82,25.05l11.69-5,5.27,5.65,6.44-5,9.05,5.88S361.67,462.85,343.79,449.93Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,389.81a106,106,0,0,1,5.28,26.36c1.29,15.78,2.93,40.49,5.71,46.06s-.85-6.13,5-28.53C369,411,349.8,382.51,349.8,382.51Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.79,396.67A105.76,105.76,0,0,1,376.33,414c10.82,11.55,27.48,29.88,33.13,32.51s-4.48-4.26-13.84-25.45c-9.5-21.49-42.21-31.85-42.21-31.85Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.93,405.35l.35-.05c.16-1.16,13.55-3.9,30.18-6.18,16.28-2.23,29.69-3.19,30.69-2.22a68.2,68.2,0,0,1-11.57-18.68,36.12,36.12,0,0,1,1.76-31.28c5.44-10.15,7.86-23.1,6-36.72-3.9-28.53-25.06-49.19-47.26-46.15s-37,28.63-33.13,57.15c2,14.79,8.69,27.47,17.74,35.82a35.21,35.21,0,0,1,10.42,33A64.09,64.09,0,0,1,324.93,405.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.23,285a13,13,0,1,1-15.82-9A12.84,12.84,0,0,1,364.23,285Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.27,274.55a6.06,6.06,0,1,1-7.37-4.17A6,6,0,0,1,354.27,274.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,397h0l0,0S386.18,397,386.19,397Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat404);
export default __webpack_public_path__ + "static/media/cat_404.4400fe221ee6d20b6b83a8c0a2f95ea4.svg";
export { ForwardRef as ReactComponent };